module.exports = __webpack_public_path__ + "img/organization-question-set.fd19cc5b.png";